<template>
  <div v-if="visible === true" class="object-obstruction-block">
    <div>
      <div>
        <form>
          <div class="field">
            <label for="input-period">
              {{ $t('route_management.obstruction_period_placeholder') }}:
            </label>
            <div id="input-period" class="input-select-field">
              <select
                style="width: 100%"
                v-model="obstruction.period_id"
              >
                <option v-for="obstructionType in obstructionTypes"
                        :value="obstructionType.key" :key="obstructionType.key">
                  {{ $t(`obstruction_type.${obstructionType.type}`) }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="obstruction.period_id !== null" class="field">
            <label for="input-from-date">
              {{ $t('obstruction.from_date') | capitalize }}:
            </label>
            <div id="input-from-date" class="input-date-field">
              <input
                type="date"
                style="width: 50%"
                :class="{'active': true}"
                v-model="obstruction.from_date"
              />
            </div>
          </div>
          <div v-if="obstruction.period_id === 1 || obstruction.period_id === 3" class="field">
            <label for="input-to-date">
              {{ $t('obstruction.to_date') | capitalize }}:
            </label>
            <div id="input-to-date" class="input-date-field">
              <input
                type="date"
                style="width: 50%"
                :class="{'active': true}"
                v-model="obstruction.to_date"
              />
            </div>
          </div>
          <div class="field">
            <label for="input-reason">
              {{ $t('obstruction.reason') | capitalize }}:
            </label>
            <div id="input-reason" class="input-textarea-field">
              <textarea
                type="text"
                :placeholder="$t('route_management.obstruction_reason_placeholder')"
                v-model="obstruction.reason"
              />
            </div>
          </div>
          <div class="field">
            <label for="input-detour">
              {{ $t('obstruction.detour') | capitalize }}:
            </label>
            <div id="input-detour" class="input-textarea-field">
              <textarea
                type="text"
                :placeholder="$t('route_management.obstruction_detour_placeholder')"
                v-model="obstruction.detour"
              />
            </div>
          </div>
          <a @click="closeForm" class="btn grey">
            {{ $t('button.cancel') | capitalize }}
          </a>
          <a
            @click="createObstruction"
            :class="[
            'btn',
            'module-color-background',
            {'disabled': (obstruction.period_id === 2) ? (obstruction.from_date === null) :
            (obstruction.from_date === null || obstruction.to_date === null)
            }]"
            :disabled="(obstruction.period_id === 2) ? (obstruction.from_date === null) :
            (obstruction.from_date === null || obstruction.to_date === null)"
          >
            {{ $t('button.save') | capitalize }}
          </a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import ObstructionTypes from '@/enums/ObstructionTypes';

export default {
  moment,
  name: 'ObjectObstructionCreate',
  props: {
    id: {
      type: Number,
      required: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
  data() {
    return {
      obstruction: {
        map_object_id: this.id,
        period_id: null,
        from_date: null,
        to_date: null,
        reason: null,
        detour: null,
      },
      obstructionTypes: ObstructionTypes,
    };
  },
  methods: {
    closeForm() {
      this.$emit('showObjectObstructionsForm', 'create', false);
    },
    async createObstruction() {
      console.log('createObstruction', this.obstruction, this.obstruction.from_date, this.obstruction.to_date);
      this.obstruction.from_date = moment(this.obstruction.from_date).format('YYYY-MM-DD');
      if (this.obstruction.period_id === 1 || this.obstruction.period_id === 3) {
        this.obstruction.to_date = moment(this.obstruction.to_date).format('YYYY-MM-DD');
      } else {
        this.obstruction.to_date = null;
      }
      this.$emit('showObjectObstructionsForm', 'create', false);
      this.$emit('createObstruction', JSON.parse(JSON.stringify(this.obstruction)));
      this.obstructionCreated();
    },
    obstructionCreated() {
      this.obstruction.period_id = null;
      this.obstruction.from_date = null;
      this.obstruction.to_date = null;
      this.obstruction.reason = null;
      this.obstruction.detour = null;
    },
  },
  watch: {
    id() {
      this.obstruction.map_object_id = this.id;
    },
  },
};
</script>

<style scoped>
  .object-obstruction-block {
    padding: 0 20px;
  }
</style>
